import { html } from 'lit';
import type { SvgIcon } from '../entities';

export const search: SvgIcon = {
  key: 'A615C30C-8C90-41F0-B0B4-98305639DF61',
  icon: html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="var(--stroke, var(--uui-color-default))"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </svg>
  `,
};
